import type { BalancesState } from 'src/store/shared/balances/types';

export enum TradingBalancesCommands {
  Balance = 'Balance',
}

export interface TradingBalancesState extends BalancesState {
  balance: TradingBalance[];
}

export interface TradingBalance {
  lastPrice: number;
  quotePrice: number;
  token: string;
  type: string;
  volume: number;
}

export interface TradingBalanceList extends TradingBalance {
  volumeUSD: number;
}
